var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"iande-label"},[_vm._t("default"),(_vm.side)?_c('span',{staticClass:"iande-label__optional"},[_vm._v(_vm._s(_vm.side))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }